// extracted by mini-css-extract-plugin
export default {"balancedarchexample":"balancedarchexample_c949ab42760ad7e319bc","description":"description_f25c940444e8894e84d9"};